import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'wsb-confirm-changes',
  templateUrl: './confirm-changes.component.html',
  styleUrls: ['./confirm-changes.component.scss'],
  standalone: false
})
export class ConfirmChangesComponent {
  @Input() label = '';
  @Input() title = '';
  checkPassword: UntypedFormControl = new UntypedFormControl('', []);

  constructor(public activeModal: NgbActiveModal) {}

  checkPwd() {
    this.activeModal.close(true);
    // this.loginService.checkPassword(this.checkPassword.value).subscribe(
    //   success => {
    //     this.activeModal.close(true);
    //   },
    //   error => {
    //     this.atlasToast.error('common_error', null);
    //   }
    // );
  }
}
